module.exports = __webpack_public_path__ + "img/man.dc9b649f.png";